export const EDIT_PERSONAL_MODAL = {
  EMAIL: "email",
  PASSWORD: "password",
  HOME_PHONE: "ph_home",
  MOBILE_PHONE: "ph_mobile",
  SET_2FA: "2fa",
};
